module.exports = __webpack_public_path__ + "img/format_comp.6a3231c3.svg";